import { Module } from "wrapper6";

var $ = jQuery;

export default class Quote extends Module {

	ready(app) {

		$(document).ready(function(){

			// if($('.all-quotes').length){

			// 	// Start quote slide

			// 	var quoteLenght = parseInt($('.quote').length);

			// 	$('.quotes').children('.quote').first().addClass('activeQuote');
			// 	setTimeout(function(){
			// 	    $('.activeQuote').css('opacity', '1');
			// 	},10);

			// 	if(quoteLenght > 1){

			// 		var i;

			// 	    for (i = 0; i < quoteLenght; i++) { 
			// 	        if(i == 0){
			// 	            $('.dots').append('<div class="dot activeDot" data-id="'+i+'"></div>');
			// 	        }else {
			// 	            $('.dots').append('<div class="dot" data-id="'+i+'"></div>');
			// 	        }
			// 	    }

			// 	}

			// 	$(document).on('click', '.dot', function(){
			// 	    var thisId = $(this).attr('data-id');
			// 	    slideTo(thisId);
			// 	});

			// 	function slide(){
			// 	    if($('.dot').length){
			// 	        var curActive = parseInt($('.activeQuote').attr('data-id')),
			// 	            nextActive = parseInt(curActive += 1);

			// 	        if(nextActive >= quoteLenght){
			// 	            nextActive = 0;
			// 	        }

			// 	        $('.activeQuote').css('opacity', '0');

			// 	        setTimeout(function(){

			// 	            $('.activeQuote').removeAttr('style');
			// 	            $('.activeQuote').removeClass('activeQuote');
			// 	            $('.activeDot').removeClass('activeDot');

			// 	            $('.quote[data-id='+nextActive+']').addClass('activeQuote');
			// 	            $('.dot[data-id='+nextActive+']').addClass('activeDot');

			// 	            setTimeout(function(){
			// 	                $('.activeQuote').css('opacity', '1');
			// 	            },10);

			// 	        }, 400);

			// 	    }
			// 	}

			// 	function slideTo(thisId){
			// 	    if(thisId != $('.activeQuote').attr('data-id')){

			// 	        $('.activeQuote').css('opacity', '0');

			// 	        setTimeout(function(){

			// 	            $('.activeQuote').removeAttr('style');
			// 	            $('.activeQuote').removeClass('activeQuote');
			// 	            $('.activeDot').removeClass('activeDot');

			// 	            $('.quote[data-id='+thisId+']').addClass('activeQuote');
			// 	            $('.dot[data-id='+thisId+']').addClass('activeDot');

			// 	            setTimeout(function(){
			// 	                $('.activeQuote').css('opacity', '1');
			// 	            },10);

			// 	        }, 400);
			// 	    }
			// 	}

			// }

		});

    }
}